export const contactsData = {
    email: 'vaibhavsinghvi254@gmail.com',
    phone: '+91-7014100989',
    address: 'Udaipur - 313001, Rajasthan, India ',

    sheetAPI: ''
}